import { memo } from 'react'
import { getCurrentUserId } from '@tabeeb/modules/account/selectors'
import { clearFoundUsersList, updateUsersSearchValue, removeOwner } from '@tabeeb/modules/sessionsPage/actions'
import { Radio, RadioGroup, Stack } from '@collaborate-health/uikit'
import { FormControlLabel } from '@mui/material'
import { useDispatch, useSelector } from '@tabeeb/store'
import { ContentSharingModelType } from '@tabeeb/contracts/main-api/swagger-main-api'
import {
  getContentSharingDestinationOptions,
  getSelectedTenant,
  getSelectedUser,
} from '@tabeeb/modules/sessionsPage/selectors/contentSharings'

interface SharingTypeSelectorProps {
  contentSharingType: ContentSharingModelType
  setSharingType: (type: ContentSharingModelType) => void
}

const SharingTypeSelector: React.FC<SharingTypeSelectorProps> = ({ contentSharingType, setSharingType }) => {
  const dispatch = useDispatch()
  const currentUserId = useSelector(getCurrentUserId)
  const selectedOwnerForSharing = useSelector((state) => getSelectedUser(state, { contentSharingType }))
  const isMergeReview = contentSharingType === ContentSharingModelType.MergeForReview
  const isCurrentUserSelected = currentUserId === selectedOwnerForSharing?.Id
  const availableOptions = useSelector((state) => getContentSharingDestinationOptions(state, { contentSharingType }))
  const selectedTenant = useSelector((state) => getSelectedTenant(state, { contentSharingType }))

  const _handleChange = (newSharingType: ContentSharingModelType) => {
    if (isMergeReview && newSharingType === ContentSharingModelType.ForReview && isCurrentUserSelected) {
      dispatch(clearFoundUsersList())
      dispatch(updateUsersSearchValue(''))
      dispatch(removeOwner())
    }

    setSharingType(newSharingType)
  }

  if (availableOptions.length < 2 || selectedTenant?.IsPredefined) {
    return null
  }

  return (
    <Stack mb={2}>
      <RadioGroup value={contentSharingType} onChange={(e) => _handleChange(parseInt(e.target.value, 10))}>
        {availableOptions.map((option) => (
          <FormControlLabel value={option.type} control={<Radio />} label={option.description} key={option.type} />
        ))}
      </RadioGroup>
    </Stack>
  )
}

export default memo(SharingTypeSelector)

